import React from 'react';
import ChangedDot from './ChangedDot';
import './sheet.css';

/**
 * Ετικέτα + στοιχείο ελέγχου στη δεξιά στήλη μιας ενότητας, με τελεία όταν το πεδίο άλλαξε. Με
 * `htmlFor` η ετικέτα είναι <label> και η εξήγηση παίρνει id `<htmlFor>-hint` (για aria-describedby).
 */
export interface SheetFieldProps {
  label: React.ReactNode;
  hint?: React.ReactNode;
  htmlFor?: string;
  changed?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const SheetField: React.FC<SheetFieldProps> = ({ label, hint, htmlFor, changed = false, className = '', children }) => (
  <div className={`xs-field ${className}`.trim()}>
    {htmlFor ? (
      <label htmlFor={htmlFor} className="xs-label">
        {label}
        {changed && <ChangedDot />}
      </label>
    ) : (
      <span className="xs-label">
        {label}
        {changed && <ChangedDot />}
      </span>
    )}
    {children}
    {hint && <p id={htmlFor ? `${htmlFor}-hint` : undefined} className="xs-field-hint">{hint}</p>}
  </div>
);

export default SheetField;
